var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "n3-tree"
  }, [_vm._l((_vm.root.childNodes), function(child) {
    return _c('n3-tree-node', {
      key: _vm.getNodeKey(child),
      attrs: {
        "node": child,
        "props": _vm.props,
        "render-content": _vm.renderContent
      }
    })
  }), _vm._v(" "), (!_vm.root.childNodes || _vm.root.childNodes.length === 0) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.emptyText))])]) : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-9d6a97cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d6a97cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tree/n3Tree.vue
// module id = 650
// module chunks = 0 1